import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import GuideContentRenderer from "../wikiComponents/guideContentRenderer";
import aivGuideData from "./aivGuide";

const AIVeronica = () => {
  const { sectionId, tabId } = useParams();
  const navigate = useNavigate();

  const matchedSections = useMemo(() => {
    return aivGuideData.id === sectionId ? aivGuideData.sections : [];
  }, [sectionId]);

  const allTabIds = useMemo(() => {
    return matchedSections.map((section) => section.id);
  }, [matchedSections]);

  useEffect(() => {
    if (matchedSections && !tabId && allTabIds.length > 0) {
      navigate(`/wiki/events/${sectionId}/${encodeURIComponent(allTabIds[0])}`, {
        replace: true,
      });
    }
  }, [sectionId, tabId, matchedSections, allTabIds, navigate]);

  const handleTabClick = (title) => {
    navigate(`/wiki/events/${sectionId}/${encodeURIComponent(title)}`);
  };

  // Find current tab data
  const currentTabData = matchedSections.find((sec) => sec.id === tabId);

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Sidebar */}
      <div className="w-full md:w-1/4 bg-[var(--panel-bg-color)] p-4 rounded-xl">
        <ul className="space-y-2">
          {matchedSections.map((section) => (
            <li key={section.id}>
              <button
                className={`w-full text-left px-4 py-2 rounded rounded-lg ${
                  section.id === tabId
                    ? "bg-[var(--button-bg-color)] text-[var(--text-color)] border border-[var(--outline2-color)] shadow"
                    : "bg-[var(--button2-bg-color)] text-[var(--text6-color)] hover:bg-[var(--button-bg-color)] hover:text-[var(--text-color)] shadow"
                }`}
                onClick={() => handleTabClick(section.id)}
              >
                {section.title}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Content Area */}
      <div className="w-full md:w-3/4 p-4 wiki-sections">
        {currentTabData ? (
          currentTabData.content.map((subdivision, idx) => (
            <div key={`subdivision-${idx}`} className="wiki-sections">
              <h4 className="wiki-section-title">{subdivision.title}</h4>
              <GuideContentRenderer content={subdivision.content || []} />
            </div>
          ))
        ) : (
          <p>No content found for this tab.</p>
        )}
      </div>
    </div>
  );
};

export default AIVeronica;
